import { gql } from 'src/__generated__'

export default gql(`
mutation logout {
  logout
}
`)
